module.exports = __webpack_public_path__ + "images/buttons/sort_by_day.gif";